// services/trackerDataService.js
import { collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export const trackerDataService = {
  async getTrackerData(userId) {
    try {
      if (!userId) return this.getDefaultTrackerData();

      // Get document directly by ID
      const trackerDocRef = doc(db, "trackers", userId);
      const trackerDoc = await getDoc(trackerDocRef);
      
      if (trackerDoc.exists()) {
        const trackerData = trackerDoc.data();
        return this.extractTrackerFields(trackerData);
      }

      // Return default data if no tracker found
      return this.getDefaultTrackerData();
    } catch (error) {
      console.error("Error fetching tracker data:", error);
      return this.getDefaultTrackerData();
    }
  },

  extractTrackerFields(trackerData) {
    const associate = trackerData.associate || {};
    const fourByFour = trackerData.fourByFour || {};
    const licensing = trackerData.licensing || {};

    return {
      // Main fields we need
      recruitsTtl: associate.recruitTtl || associate.recruitsTtl || 0,
      personalPoints: associate.personalPoints || 0,
      licensesTtl: associate.licensesInTtl || associate.licensesTtl || 0,
      registrationsBase: associate.registrationsBase || 0,
      
      // Additional fields for reference
      multiHanded: associate.multiHanded || fourByFour.finish1stRecruit || false,
      tenThreeRulesGoals: associate.tenThreResultsGoals || fourByFour.personalSavings || false,
      selfImprovement: associate.selfImprovement || false,
      getLicense: associate.getLicense || licensing.licensed || fourByFour.licensed || false,
      registerConvention: associate.registrationConvention || false,
      
      // User info
      name: trackerData.name || trackerData.firstName || trackerData.email,
      email: trackerData.email
    };
  },

  getDefaultTrackerData() {
    return {
      recruitsTtl: 0,
      personalPoints: 0,
      licensesTtl: 0,
      registrationsBase: 0,
      multiHanded: false,
      tenThreeRulesGoals: false,
      selfImprovement: false,
      getLicense: false,
      registerConvention: false,
      name: "",
      email: ""
    };
  }
};